export default {
    price: 0.00,
    price_formatted: '',
    count: 0,
    items: {},

    getItems() {
        return this.items;
    },

    getCount() {
        return this.count;
    },

    getPrice() {
        return this.price;
    },

    getPriceFormatted() {
        return this.price_formatted;
    },

    async addItem(id, quantity = 1) {
        await axios.post('/akademia/envishop/cart', {id: id, quantity: quantity})
            .then(response => {
                this.update()
            })
            .catch((err) => {
                throw err;
            });
    },
    removeItem(id) {
        axios.delete('/akademia/envishop/cart/' + id)
            .then(response => {
                this.update()
            })
            .catch((err) => {
            });
    },
    removeItems(id) {
        axios.delete('/akademia/envishop/cart/remove-items/' + id)
            .then(response => {
                this.update()
            })
            .catch((err) => {
            });
    },
    update() {
        axios.get('/akademia/envishop/cart/update')
            .then(response => {
                this.price = response.data.price;
                this.price_formatted = response.data.price_formatted;
                this.count = response.data.count;
                this.items = response.data.items;
            })
            .catch((err) => {
            });
    }
}
